module.exports = __webpack_public_path__ + "img/esyoil-wagen.b95efab.jpeg";